import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/DuesReport';


const DuesReport = ({ t }) => (
  <Container>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

DuesReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(DuesReport);
